module.exports = __webpack_public_path__ + "static/media/address.a23093fb.png";